import { TabList } from 'react-tabs';

export default TabList;
